import es from '../translations/es.json';
export default es;



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/locale-data/es.js